"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findColumnWidthConstants = exports.distribute = exports.calculateColumnWidth = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var scrollbarVisible = function scrollbarVisible(elem) {
  var el = typeof elem === "string" ? document.getElementById(elem) : elem;
  return Boolean(el) && el.scrollHeight > el.clientHeight;
};

var calculateColumnWidth = function calculateColumnWidth(element, numColumns) {
  var fixedColumnWidths = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var subtractScrollbar = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!element) return [0, 0];
  var n = Math.max(numColumns, 1);
  var parent = element.parentElement;
  var totalWidth = element.offsetWidth - (subtractScrollbar && scrollbarVisible(parent) ? 15 : 0);
  var freeSpace = Math.max(totalWidth - fixedColumnWidths, 0);
  var baseWidth = Math.floor(freeSpace / n);
  var remaining = Math.floor(freeSpace % n);
  return [baseWidth, remaining];
};

exports.calculateColumnWidth = calculateColumnWidth;

var distribute = function distribute(rem, numColumns) {
  var n = Math.max(numColumns, 1);

  var result = _toConsumableArray(Array(n)).fill(0);

  var inc = Math.ceil(rem / n);
  var dec = rem;
  var i = 0;

  while (dec > 0 && i < n) {
    result[i] += inc;
    dec -= inc;
    i++;
  }

  return result.reverse();
};

exports.distribute = distribute;

var findColumnWidthConstants = function findColumnWidthConstants(columns) {
  return columns.reduce(function (pv, c) {
    return {
      fixedWidth: pv.fixedWidth + (c.width || 0),
      remainingCols: pv.remainingCols + (c.width === undefined ? 1 : 0)
    };
  }, {
    fixedWidth: 0,
    remainingCols: 0
  });
};

exports.findColumnWidthConstants = findColumnWidthConstants;